/* eslint-disable no-unused-vars */
import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { modifyDataCon } from "../../Redux/apiCalls";
import Navbar from "../../components/Bar/Navbar";
import { Desc, DescP, DescSpan, H3 } from "../transaction/transHistory.styles";
import {
  Btn,
  Container,
  Form,
  FormWrapper,
  Input,
  InputContainer,
  InputTitle,
  Wrapper,
} from "../Settings/edit.styles";
import Footer from "../../components/footer/Footer";

const ModifyData = () => {
  const location = useLocation();
  const Id = Number(location.pathname.split("/")[3]);
  const dataList = useSelector((state) =>
    state.airtimeConverter?.dataConList?.data?.find((data) => data.id === Id)
  );
  const { isFetching } = useSelector((state) => state.airtimeConverter);

  console.log(dataList);

  const [inputNameData, setInputNameData] = useState(dataList?.name);
  const [inputPrice, setInputPrice] = useState(dataList?.price);
  const [inputAmount, setInputAmount] = useState(dataList?.amount);
  const [inputNote, setInputNote] = useState(dataList?.note);
  const [inputServer, setInputServer] = useState(dataList?.server);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleInputNameChange = (event) => {
    setInputNameData(event.target.value);
  };

  const handleInputPriceChange = (event) => {
    setInputPrice(event.target.value);
  };

  const handleInputAmountChange = (event) => {
    setInputAmount(event.target.value);
  };

  const handleInputNoteChange = (event) => {
    setInputNote(event.target.value);
  };

  const handleInputServerChange = (event) => {
    setInputServer(event.target.value);
  };

  const handleUpdateClick = async (e) => {
    e.preventDefault();

    const { success, message } = await modifyDataCon(dispatch, {
      id: dataList.id,
      name: inputNameData,
      provider_price: inputPrice,
      amount: inputAmount,
      status: 1,
      note: inputNote,
      discount: "0.75",
    });

    if (success) {
      toast.success(`${inputAmount} modified successfully!`);
      setTimeout(() => navigate("/reseller/datacontrol"), 3000);
    } else {
      toast.error(`Error: ${message}`);
    }
  };

  return (
    <>
      <ToastContainer />
      <Navbar />
      <Container>
        <Wrapper>
          <Desc>
            <H3>Modify Data Plan</H3>
            <DescP>
              Data / <DescSpan>Modify Data Plan</DescSpan>
            </DescP>
          </Desc>
          <FormWrapper onSubmit={handleUpdateClick}>
            <Form>
              <InputContainer>
                <InputTitle>Product Name</InputTitle>
                <Input
                  type="text"
                  onChange={handleInputNameChange}
                  value={inputNameData}
                />
              </InputContainer>
              <InputContainer>
                <InputTitle>Provider Price</InputTitle>
                <Input
                  type="number"
                  onChange={handleInputPriceChange}
                  value={inputPrice}
                  name="name"
                />
              </InputContainer>
              <InputContainer>
                <InputTitle>Your Price</InputTitle>
                <Input
                  type="number"
                  onChange={handleInputAmountChange}
                  value={inputAmount}
                  name="name"
                />
              </InputContainer>
              {/* <InputContainer>
                <TextField
                  select
                  label="Activate"
                  variant="outlined"
                  style={{ width: "100%" }}
                >
                  <MenuItem key="Activate" value="Activate">
                    Activate
                  </MenuItem>
                  <MenuItem key="Deactivate" value="Deactivate">
                    Deactivate
                  </MenuItem>
                </TextField>
              </InputContainer> */}
              {/* <InputContainer>
                <TextField
                  select
                  label="1"
                  variant="outlined"
                  style={{ width: "100%" }}
                  onChange={handleInputServerChange}
                  value={inputServer}
                >
                  {Server.map((server) => (
                    <MenuItem key={server.id} value={server.value}>
                      {server.value}
                    </MenuItem>
                  ))}
                </TextField>
              </InputContainer> */}
              <InputContainer>
                <InputTitle>Note</InputTitle>
                <Input
                  type="text"
                  onChange={handleInputNoteChange}
                  value={inputNote}
                  placeholder="Enter Note (Optional)"
                />
              </InputContainer>
            </Form>
            <Btn type="submit">{isFetching ? "Updating" : "Update"}</Btn>
            <ToastContainer />
          </FormWrapper>
        </Wrapper>
      </Container>
      <Footer />
    </>
  );
};

export default ModifyData;
